import { Checkbox, CheckboxProps } from '@chakra-ui/react';
import useValidationForRequiredField from '@/form/useValidationForRequiredField';
import { Field, getIn } from 'formik';
import FormElementForCheckboxes from '@components/presentational/Form/FormElementForCheckboxes';
import React from 'react';

type CheckboxFormProps = CheckboxProps & {
  children: React.ReactNode;
  name: string;
  validate?: (value: string) => string | undefined;
  required?: boolean;
  requiredMessage?: string;
};

export default function CheckboxForm({
  children,
  name,
  validate,
  required,
  requiredMessage,
  ...props
}: CheckboxFormProps) {
  const validateForm = useValidationForRequiredField(
    required,
    validate,
    requiredMessage
  );

  return (
    <Field name={name} validate={validateForm}>
      {({ field, form }) => {
        const errors = getIn(form.errors, name);
        const touched = getIn(form.touched, name);
        const hasError = errors && touched;

        let errorsComponents = [];
        if (errors) {
          errorsComponents = errors.map(errorItem => (
            <li key={errorItem}>{errorItem}</li>
          ));
        }

        return (
          <FormElementForCheckboxes
            isInvalid={hasError}
            isRequired={required}
            errorMessage={errorsComponents}
          >
              <Checkbox
                {...props}
                onChange={evt => {
                  field.onChange(name)(evt.target.checked);
                }}
                defaultChecked={field.value}
                isRequired={required}
              >
                {children}
              </Checkbox>
          </FormElementForCheckboxes>
        );
      }}
    </Field>
  );
}
